let portalFeaturesCache = { email: null, features: null };
let portalFeaturesInflight = null;
let portalFeaturesFetchGeneration = 0;
let rbacCache = { email: null, permissions: null };
let rbacInflight = null;
let rbacFetchGeneration = 0;

export function getPortalFeaturesCache(email) {
  if (!email || portalFeaturesCache.email !== email) {
    return null;
  }

  return portalFeaturesCache.features;
}

export function setPortalFeaturesCache(email, features) {
  portalFeaturesCache = { email, features };
}

export function getPortalFeaturesInflight() {
  return portalFeaturesInflight;
}

export function setPortalFeaturesInflight(request) {
  portalFeaturesInflight = request;
}

export function currentPortalFeaturesFetchGeneration() {
  return portalFeaturesFetchGeneration;
}

export function invalidatePortalFeaturesFetch() {
  portalFeaturesFetchGeneration += 1;
  portalFeaturesInflight = null;
}

export function getRBACCache(email) {
  if (!email || rbacCache.email !== email) {
    return null;
  }

  return rbacCache.permissions;
}

export function setRBACCache(email, permissions) {
  rbacCache = { email, permissions };
}

export function getRBACInflight() {
  return rbacInflight;
}

export function setRBACInflight(request) {
  rbacInflight = request;
}

export function currentRBACFetchGeneration() {
  return rbacFetchGeneration;
}

export function invalidateRBACFetch() {
  rbacFetchGeneration += 1;
  rbacInflight = null;
}

export function clearAuthCaches() {
  portalFeaturesCache = { email: null, features: null };
  portalFeaturesFetchGeneration += 1;
  portalFeaturesInflight = null;
  rbacCache = { email: null, permissions: null };
  rbacFetchGeneration += 1;
  rbacInflight = null;
}

export function notifyAuthContextChanged() {
  clearAuthCaches();
  window.dispatchEvent(new Event("portal-features-changed"));
  window.dispatchEvent(new Event("rbac-changed"));
}
